// SETTINGS ACTION
export const DOCUMENT_TO_SLIDE='DOCUMENT_TO_SLIDE'
export const SLIDE_TO_LLM="SLIDE_TO_LLM"
export const SLIDES_TO_LLM_IN_PROGRESS="SLIDES_TO_LLM_IN_PROGRESS"
export const SLIDES_TO_LLM_PROGRESSION="SLIDES_TO_LLM_PROGRESSION"
export const SLIDES_TO_LLM_RESPONSE='SLIDES_TO_LLM_RESPONSE';
export const RESET_SLIDES_2_VIDEO='RESET_SLIDES_2_VIDEO'
export const SELECT_SLIDE="SELECT_SLIDE";
export const UPDATE_SLIDES="UPDATE_SLIDES";
export const SELECT_GENERATION_MODE="SELECT_GENERATION_MODE"
export const SELECT_CUSTOM_INSTRUCTION="SELECT_CUSTOM_INSTRUCTION"
export const OPEN_PANEL_OPTIONS="OPEN_PANEL_OPTIONS"
export const SLIDES_GENERATION_AUTO_MODE="AUTO_MODE"
